import { useEffect, useRef } from 'react';

const scrollSelectedResultIntoView = (
  selectedIndex: number | undefined | null,
  rowRefs: Array<HTMLDivElement | null>,
  container: HTMLDivElement | null
): void => {
  if (selectedIndex === undefined || selectedIndex === null) return;
  const node = rowRefs[selectedIndex];
  if (!node || !container) return;
  const nodeRect = node.getBoundingClientRect();
  const containerRect = container.getBoundingClientRect();
  if (
    nodeRect.top < containerRect.top ||
    nodeRect.bottom > containerRect.bottom
  ) {
    node.scrollIntoView({ block: 'nearest' });
  }
};

/**
 * Hook to auto-scroll a list so the selected item is visible.
 * @param selectedIndex The index of the selected item
 * @returns An object containing refs for the container and row elements.
 */
export const useListAutoScroll = (
  selectedIndex: number
): {
  containerRef: React.RefObject<HTMLDivElement | null>;
  rowRefs: React.RefObject<(HTMLDivElement | null)[]>;
} => {
  const containerRef = useRef<HTMLDivElement>(null);
  const rowRefs = useRef<Array<HTMLDivElement | null>>([]);

  useEffect(() => {
    scrollSelectedResultIntoView(
      selectedIndex,
      rowRefs.current,
      containerRef.current
    );
  }, [selectedIndex]);

  return { containerRef, rowRefs };
};
